import { cn } from 'cn';
import { type ReactNode } from 'react';

import { ParagraphWrapper } from '@vestigas/ui/atoms';

type P = {
  readonly callToAction?: ReactNode;
  readonly errorCode?: string;
  readonly illustration?: ReactNode;
  readonly message: string | string[];
  readonly title: string;
} & ComponentStyling;

export const ErrorPage = ({
  callToAction,
  className,
  errorCode,
  illustration,
  message,
  style,
  title,
}: P) => (
  <div className={cn('flex h-full flex-col', className)} style={style}>
    <div className="relative flex flex-1 flex-col items-center justify-center gap-4">
      {title ? (
        <h1 className="line-clamp-1 text-center text-4xl tracking-tight text-balance text-tiga-text-default">
          {title}
        </h1>
      ) : null}
      {errorCode ? (
        <p className="absolute top-1/2 left-1/2 -z-10 -translate-1/2 bg-gradient-to-t from-tiga-text-lighter/24 to-tiga-text-lightest/11 bg-clip-text text-[32rem] font-bold text-transparent">
          {errorCode}
        </p>
      ) : null}
      <ParagraphWrapper
        className="text-tiga-text-default"
        paragraphs={message}
      />
      {callToAction}
      {illustration}
    </div>
  </div>
);
